import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "mailing-lists",
    name: "mailing-lists",
    component: () => import("./pages/MailingListsPage.vue"),
    meta: {
      requiresAuth: true,
      requiresStaff: true,
      title: "menu.mailing_lists",
    },
  },
];
